@if (data.title) {
  <h4 mat-dialog-title>
    @if (data.icon) {
      <span [innerHTML]="data.icon"></span>
    }
    {{ data.title | translate}}
  </h4>
}
<div mat-dialog-content class="dialog-content-pad-15">
  <p [innerHTML]="message"
     class="content"></p>
</div>
<div mat-dialog-actions>
  <button [mat-dialog-close]="false"
    class="btn btn-default"
  data-cy="cancel-btn">{{ (data.cancelBtnLabel || 'cancel') | translate}}</button>
  <button [mat-dialog-close]="true"
    class="btn"
    data-cy="confirm-btn"
    ngClass="btn-{{data.confirmBtnType || 'default'}}">
    {{ (data.confirmBtnLabel ? data.confirmBtnLabel : 'ok') | translate}}
  </button>
</div>
